import { render, staticRenderFns } from "./Dropdown.vue?vue&type=template&id=54afa19f&scoped=true&"
import script from "./Dropdown.vue?vue&type=script&lang=ts&"
export * from "./Dropdown.vue?vue&type=script&lang=ts&"
import style0 from "./Dropdown.vue?vue&type=style&index=0&id=54afa19f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54afa19f",
  null
  
)

export default component.exports